
import { defineComponent } from "vue";
import Card3 from "@/components/cards/Card3.vue";

export default defineComponent({
  name: "connections",
  components: {
    Card3,
  },
});
